/* cr3d-main.js: the 3D Compact Rack builder inside the real Product information section (main-product). v2, 3 Nov 2026.
   sections/cr3d-main-addon.liquid (placed before main) carries the templates and the config; this file:
   - mounts them into main-product: the 3D square + the 2x2 of views + the photos into #product-media (main's gallery
     goes; its campaign label moves onto the 3D square), the Shelves step after main's variant picker and stock line
     (Rebuy's "Recommended Add Ons" follows it; its ticked add-ons go in after the build), the build's "Add to Quote"
     link under Add to cart, the dialogs;
   - keeps the build: height and colour from main's own variant picker (on:variant:change), the 4 shelves from the shelf
     cards (they go in top to bottom in the order chosen), a ?build= link restores the shelves;
   - puts the build into main's price (the rack variant + 4 shelves, campaign price first; "From" until 4 shelves), the
     Shop Pay line (every variant's entry), the Finance amounts, the Add to cart label ("Choose N more shelves" until all 4
     are chosen) and the phone sticky bar's variant chip price, again after every Height / Colour change (main re-renders
     those parts);
   - takes over main's Add to cart (and the sticky bar, which clicks it): an incomplete build scrolls to the shelves, a
     complete one goes in as one build (CR3DCart.addBuild: rack + shelves, each its own line, x main's quantity).
   James's rules (window.CR, cr3d-rules.js) and the 3D (cr3d-view.js, loaded when the square is near) are unchanged; the
   3D finds its elements under [data-cr3d], which this file sets on main's section. Leaves main-product's own code alone. */
(function () {
  'use strict';
  var G = window, D = document, NS = G.CR3D || (G.CR3D = {});
  var addon = D.querySelector('[data-cr3d-addon]');
  var main = D.querySelector('.cc-main-product');
  if (!addon || !main || !G.CR || main.hasAttribute('data-cr3d')) return;
  var CR = G.CR;
  var cfg = {};
  try { cfg = JSON.parse((addon.querySelector('[data-cr3d-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  if (!cfg.variants || !cfg.rack_ids) return;   // no config: leave main-product as it is
  NS.config = cfg;
  var T = cfg.t || {}, V = cfg.variants || {}, RID = cfg.rack_ids || {};
  var mode = cfg.mode || 'buy';   // buy | quote (US) | noprice
  var BUY = mode === 'buy';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var $ = function (s) { return main.querySelector(s); };
  var phone = G.matchMedia('(max-width: 768.98px)'), desk = G.matchMedia('(min-width: 769px)');

  // ---------- mount into main-product ----------
  // [data-cr3d] on main's section: cr3d-view.js (and the Klaviyo hub guard) look for it; the 3D's elements are inside
  main.setAttribute('data-cr3d', ''); main.setAttribute('data-mode', mode); main.classList.add('cr3d-main');
  var media = main.querySelector('#product-media');
  var mt = addon.querySelector('template[data-cr3d-media]');
  if (media && mt) {
    // the pinned phone band takes its gap above from Mobile PDP header's "Space above photos" (#product-media's margin)
    try { main.style.setProperty('--cr3d-mgap', getComputedStyle(media).marginTop); } catch (e) {}
    media.prepend(mt.content.cloneNode(true));
    var labels = media.querySelector('media-gallery .product-media-labels') || [].filter.call(media.querySelectorAll('.product-media-labels'), function (x) { return !x.closest('.cr3d-media'); })[0];
    var slot = media.querySelector('[data-cr3d-labels]');
    if (slot) { if (labels) slot.replaceWith(labels); else slot.remove(); }
    [].slice.call(media.children).forEach(function (el) { if (!el.classList.contains('cr3d-media')) el.remove(); });
    media.classList.add('cr3d-media-host');
  }
  var shelvesEl = null, quoteEl = null;
  (function () {
    var st = addon.querySelector('template[data-cr3d-shelves]');
    if (st) {
      shelvesEl = st.content.firstElementChild.cloneNode(true);
      // a sibling after main's variant picker block and its stock line (never inside them: variant changes replace those),
      // so the stock / lead-time message stays under Height / Colour as on main-product; Rebuy's add-ons follow the shelves
      var opts = $('.product-info__block.product-options');
      var form = $('product-form');
      var anchor = opts || (form && form.closest('.product-info__block'));
      var inv = opts && opts.nextElementSibling;
      while (inv && !inv.classList.contains('product-info__block')) inv = inv.nextElementSibling;   // skip main's <link> / <script>
      if (inv && inv.classList.contains('product-inventory')) inv.after(shelvesEl);
      else if (opts) opts.after(shelvesEl);
      else if (anchor) anchor.before(shelvesEl);
      else ($('.product-info__sticky') || $('.product-info') || main).appendChild(shelvesEl);
    }
    var qt = addon.querySelector('template[data-cr3d-quote-link]');
    var pf = $('product-form');
    if (qt && BUY && pf) {
      quoteEl = qt.content.firstElementChild.cloneNode(true);
      (pf.closest('.product-info__block') || pf).after(quoteEl);
    }
    // the dialogs live in main's section (the add-on's own box is hidden)
    addon.querySelectorAll('dialog').forEach(function (d) { main.appendChild(d); });
  })();

  // ---------- money: the page's own currency format (Liquid's money filter on 1234.56) ----------
  var MS = String(cfg.money_sample || '£1,234.56'), MM = MS.match(/1(\D?)234(\D)56/);
  function money(cents) {
    var n = Math.round(Number(cents) || 0), neg = n < 0; n = Math.abs(n);
    var th = MM ? MM[1] : ',', dc = MM ? MM[2] : '.';
    var s = (n / 100).toFixed(2).split('.'), whole = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    var num = whole + dc + s[1];
    return (neg ? '-' : '') + (MM ? MS.replace(MM[0], num) : '£' + num);
  }

  // ---------- state (as cr3d-app.js: James's rules, 1 bay, shelves required, each shelf chosen) ----------
  var colourByName = function (name) { name = String(name || '').toLowerCase(); return CR.COLOURS.filter(function (c) { return c.name.toLowerCase() === name; })[0] || null; };
  var REQ = cfg.storage_required !== false;
  var MAXB = Math.max(1, Math.min(4, parseInt(cfg.max_bays, 10) || 1)), FIXED = MAXB === 1 && REQ;
  var ADDONS = false;   // v2: height, colour and shelves only
  var SLOTS = cfg.shelf_mode !== 'layouts' && FIXED;
  var LIST = cfg.shelves_layout !== 'grid', NOTES = cfg.shelf_notes || {};
  var SHELF_TYPES = [['ball', T.shelf_ball || 'Ball'], ['flat', T.shelf_flat || 'Flat'], ['hex', T.shelf_hex || 'Hex'], ['round', T.shelf_round || 'Round'], ['bumper', T.shelf_bumper || 'Bumper']];
  var SHELF_SKU = { ball: '22-0613', flat: '22-0606', hex: '22-0602', round: '22-0609', bumper: '22-0598' };   // 1.2m
  var SHELF_NAME = { ball: '3 Series Ball Shelf - 1.2m', flat: '3 Series Flat Shelf with Rubber - 1.2m', hex: '3 Series Hex Dumbbell Shelf - 1.2m',
    round: '3 Series Round-Dumbbell Shelf - 1.2m', bumper: '3 Series Bumper Shelf - 1.2m' };
  function shelvesOf(v) { return [0, 1, 2, 3].map(function (i) { var x = v && v[i]; return SHELF_SKU[x] ? x : null; }); }
  function packShelves(v) { var list = shelvesOf(v).filter(Boolean); while (list.length < 4) list.push(null); return list; }
  var shelvesLeft = function (s) { return SLOTS ? shelvesOf(s.shelves).map(function (x, i) { return x ? 0 : i + 1; }).filter(Boolean) : []; };
  var typeName = function (x) { var o = SHELF_TYPES.filter(function (o) { return o[0] === x; })[0]; return o ? o[1] : ''; };
  var shelfCounts = function (v) { var c = {}; shelvesOf(v).forEach(function (x) { if (x) c[x] = (c[x] || 0) + 1; }); return c; };
  // one more goes in the highest empty slot (Shelf 1 = top); one fewer takes out the lowest of that kind, the ones under move up
  var setShelfCount = function (v, type, n) {
    var list = shelvesOf(v).filter(Boolean), have = list.filter(function (x) { return x === type; }).length;
    for (; have < n && list.length < 4; have++) list.push(type);
    for (; have > n; have--) list.splice(list.lastIndexOf(type), 1);
    while (list.length < 4) list.push(null);
    return list;
  };
  // the shelves in the order they go in, top to bottom (as picked), e.g. "Bumper, Ball, Ball, Hex"
  var shelfList = function (v) { return shelvesOf(v).filter(Boolean).map(typeName).join(', '); };
  var slotName = function (i) { return (T.shelf || 'Shelf') + ' ' + (i + 1) + (i === 0 ? ' (' + (T.top || 'top') + ')' : i === 3 ? ' (' + (T.bottom || 'bottom') + ')' : ''); };
  function summaryOf(st) {
    if (!SLOTS) return CR.summary(st);
    var sh = shelvesOf(st.shelves), n = sh.filter(Boolean).length;
    return CR.summary(st).split(' · ').filter(function (x) { return !/^(\d+ bays?|plate storage |storage )/.test(x); })
      .concat(n === 4 ? [(T.shelves_order || 'Shelves top to bottom') + ': ' + shelfList(st.shelves)] : n ? [n + ' of 4 shelves'] : []).join(' · ');
  }
  function detailsOf(st) {
    if (!SLOTS) return CR.details(st);
    var sh = shelvesOf(st.shelves);
    return CR.details(st).filter(function (d) { return d.label === 'Height' || d.label === 'Rack colour'; })
      .concat(sh.map(function (x, i) { return { label: slotName(i), value: x ? typeName(x) : '—' }; }));
  }
  var LAYOUT_SHELF_SKUS = /^(22-0613|22-0606|22-0602|22-0598|22-0739)$/;
  function skuRows(s) {
    var list = CR.skuList(s);
    if (!SLOTS || !s.shelves) return list;
    var rows = list.rows.filter(function (r) { return !LAYOUT_SHELF_SKUS.test(r.sku); }), count = {};
    s.shelves.forEach(function (x) { if (x) count[x] = (count[x] || 0) + 1; });
    Object.keys(count).forEach(function (x) { rows.push({ sku: SHELF_SKU[x], name: SHELF_NAME[x], qty: count[x] }); });
    return { rows: rows, todo: list.todo };
  }
  function limit(s) {
    if (!s || typeof s !== 'object') return s;
    if ((+s.bays || 0) > MAXB) { s.bays = MAXB; s.spacing = null; }
    if (FIXED) { s.plate = 'yes'; s.plateSide = 'outside'; }
    if (SLOTS) { s.storage = 'yes'; s.storageSide = 'inside'; s.layout = 'ball-flat-hex-bumper'; }
    if (!ADDONS) { s.nexus = 'no'; s.smith = 'no'; s.wbt = 'no'; }
    return s;
  }
  var DEF_LAYOUT = CR.LAYOUTS.some(function (L) { return L.id === cfg.default_layout; }) ? cfg.default_layout : CR.LAYOUTS[0].id;
  // height / colour of a rack variant id (main's picker), from the section's rack_ids
  function rackOf(id) { var r = RID[String(id)]; if (!r) return null; var c = colourByName(r.c); return { height: r.h === '2.4' ? '2.4' : '2.2', colour: c ? c.hex : null }; }
  function pickerRack() {
    var inp = main.querySelector('form.js-product-form-main input[name="id"]') || main.querySelector('input[name="id"]');
    return inp && inp.value ? rackOf(inp.value) : null;
  }
  function defaults() {
    var s = CR.blank(), c = colourByName(cfg.initial && cfg.initial.colour), r = pickerRack();
    s.height = r ? r.height : (cfg.initial && cfg.initial.height === '2.4' ? '2.4' : '2.2');
    s.colour = r && r.colour ? r.colour : (c ? c.hex : '#000000');
    s.bays = 1; s.plate = 'yes'; s.plateSide = 'outside'; s.nexus = 'no'; s.smith = 'no'; s.wbt = 'no';
    if (REQ) { s.storage = 'yes'; s.storageSide = 'inside'; s.layout = DEF_LAYOUT; } else s.storage = 'no';
    return s;
  }
  function encode(s) { try { var j = JSON.stringify(s); return btoa(unescape(encodeURIComponent(j))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); } catch (e) { return ''; } }
  function decode(v) { try { v = String(v).replace(/-/g, '+').replace(/_/g, '/'); return JSON.parse(decodeURIComponent(escape(atob(v)))); } catch (e) { return null; } }
  function keepShelves(r, prev) {
    var s = r.s;
    if (s.storage === 'yes' && s.storageSide && s.layout) return r;
    var n = {}, k; for (k in s) n[k] = s[k];
    n.storage = 'yes'; n.layout = s.layout || (prev && prev.layout) || DEF_LAYOUT;
    n.storageSide = CR.storageInsideOpen(n) ? 'inside' : CR.storageOutsideOpen(n) ? 'outside' : null;
    if (!n.storageSide) { n.plate = 'yes'; n.plateSide = 'outside'; n.storageSide = 'inside'; }
    return CR.normalise(n);
  }
  // a ?build= link restores the shelves (height and colour are main's picker's: the page's ?variant= or its first variant);
  // a reload starts bare again
  var fromUrl = null;
  var navType = ''; try { var navE = G.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; navType = navE ? navE.type : ''; } catch (e) {}
  if (navType === 'reload') { try { var u0 = new URL(location.href); if (u0.searchParams.has('build')) { u0.searchParams.delete('build'); history.replaceState(history.state, '', u0); } } catch (e) {} }
  else { try { fromUrl = decode(new URLSearchParams(location.search).get('build') || ''); } catch (e) { fromUrl = null; } }
  var state = (function () {
    var s0 = defaults();
    var r0 = CR.normalise(limit(s0));
    if (REQ) r0 = keepShelves(r0, null);
    var st = r0.s;
    if (SLOTS) st.shelves = packShelves(fromUrl && fromUrl.shelves);
    else if (fromUrl && fromUrl.layout && CR.LAYOUTS.some(function (L) { return L.id === fromUrl.layout; })) st.layout = fromUrl.layout;
    return st;
  })();
  NS.state = state;
  // the loading picture is the bare 2.2m black rack: another height / colour or a saved build gets the loading message instead
  (function () {
    var poster = $('[data-cr3d-poster]'); if (!poster) return;
    var want = String(poster.getAttribute('data-cr3d-poster')).trim().split(/\s+/);
    var shelves = shelvesOf(state.shelves).filter(Boolean).length;
    if (shelves || state.height !== want[0] || (CR.normHex(state.colour) || '') !== (CR.normHex(want[1]) || '')) {
      poster.hidden = true;
      var pTile = $('img[data-cr3d-poster-tile]');
      if (pTile) { pTile.removeAttribute('srcset'); pTile.removeAttribute('src'); pTile.closest('.cr3d__tile').classList.remove('is-ready'); }
    }
  })();

  function set(patch, why) {
    var poster = $('[data-cr3d-poster]'); if (poster) poster.hidden = true;
    var pTile = $('img[data-cr3d-poster-tile]'); if (pTile) pTile.closest('.cr3d__tile').classList.add('is-stale');
    var next = {}, k;
    for (k in state) next[k] = state[k];
    for (k in patch) next[k] = patch[k];
    var r = CR.normalise(limit(next));
    if (REQ) r = keepShelves(r, state);
    if (SLOTS) r.s.shelves = shelvesOf(next.shelves);
    state = r.s; NS.state = state;
    if (why !== 'variant' || shelvesOf(state.shelves).some(Boolean)) { try { var u = new URL(location.href); u.searchParams.set('build', encode(state)); history.replaceState(history.state, '', u); } catch (e) {} }
    renderShelves();
    if (NS.view) NS.view(state);
    apply();
  }

  // ---------- parts, matched to Shopify (cr3d-app.js match(), 1 bay: the rack variant + the shelves) ----------
  var nice = function (name) { return String(name || '').replace(/^\[Child Part\]\s*/i, '').replace(/^BLK BOX\s+/i, ''); };
  var FRAME = { '2.2': '22-0923', '2.4': '22-0924' }, PEGS = '25-0017';
  var RACK = { '2.2': '22-0558', '2.4': '22-0530' };
  var base = function (sku) { return String(sku || '').replace(/^(\d{2}-\d{4})-(?:\d{4}|CSTM)$/, '$1'); };
  function find(sku) { var v = V[sku]; return v && v.id ? v : null; }
  var MAPS_TO = { '22-0925': '24-0198', '22-0926': '24-0202' };
  var COLOURED = /^(22-0558|22-0530|22-061[6-9]|25-0183|25-0185|25-0387|25-0388)$/;
  var WITH_ARM = { '25-0183': '25-0185', '25-0387': '25-0388' }, ARM = '25-0184';
  var BLACK_PRICED = /^(25-0183|25-0185|25-0387|25-0388)$/;
  function match(s) {
    var list = skuRows(s), rows = list.rows, out = { rows: rows, todo: list.todo, lines: [], total: 0, sale: 0, missing: [], unavailable: [], reason: '' };
    var c = CR.colourOf(s.colour), black = !c || c.hex === '#000000';
    out.shelvesLeft = shelvesLeft(s);
    if (list.todo.length) { out.reason = 'todo'; return out; }
    if (!BUY) { out.reason = mode; return out; }
    var note = null;
    function pick(b) {
      note = null;
      var v = COLOURED.test(b) && !black ? find(CR.colourSku(b, s.colour)) : find(b);
      if (!v && !black && BLACK_PRICED.test(b) && c && !c.custom) { v = find(b); if (v) note = c.name; }
      return v && v.price > 0 ? v : null;
    }
    function add(v, qty, name, role) {
      if (!v) { out.missing.push({ name: name, qty: qty }); return; }
      var props = note ? {} : null; if (note) props[T.colour_property || 'Colour'] = note;
      for (var i = 0; i < out.lines.length; i++) if (out.lines[i].variantId === v.id) { out.lines[i].quantity += qty; return; }
      var off = v.available === false;
      if (off && out.unavailable.indexOf(v.title) < 0) out.unavailable.push(v.title);
      out.lines.push({ variantId: v.id, quantity: qty, title: v.title + (note ? ' · ' + note : ''), sku: v.sku, price: v.price, pct: +v.pct || 0, role: role, unavailable: off, properties: props });
    }
    var bays = 0;
    rows.forEach(function (r) { if (base(r.sku) === FRAME[s.height]) bays += r.qty; });
    if (bays) add(pick(RACK[s.height]), bays, T.rack_name || '3 Series Compact Rack', 'rack');
    var arms = 0;
    rows.forEach(function (r) { if (base(r.sku) === ARM) arms += r.qty; });
    rows.forEach(function (r) {
      var b = base(r.sku), n = r.qty;
      if (b === FRAME[s.height] || b === PEGS) return;
      if (b === ARM) return;
      if (WITH_ARM[b] && arms) { var k = Math.min(n, arms); arms -= k; n -= k; add(pick(WITH_ARM[b]), k, nice(r.name) + ' ' + (T.with_arm || 'with extension arm'), 'attachment'); }
      if (n) add(pick(MAPS_TO[b] || b), n, nice(r.name), 'attachment');
    });
    if (arms) add(pick(ARM), arms, T.arm_name || 'Wall Ball Target Extension Arm', 'attachment');
    out.total = out.lines.reduce(function (a, l) { return a + l.price * l.quantity; }, 0);
    // the campaign price (e.g. BLK November), each part by its own % (snippets/campaign-pct): what checkout charges
    out.sale = out.lines.reduce(function (a, l) { return a + Math.round(l.price * l.quantity * (100 - l.pct) / 100); }, 0);
    out.reason = c && c.custom ? 'custom' : out.missing.length ? 'missing' : out.unavailable.length ? 'unavailable' : 'cart';
    if (out.shelvesLeft.length && out.reason === 'cart') out.reason = 'todo';
    return out;
  }
  // the cheapest shelf (campaign price), for the "From" price while shelves are still to choose
  var CHEAP = (function () {
    var best = null, bp = Infinity;
    SHELF_TYPES.forEach(function (o) { var v = V[SHELF_SKU[o[0]]]; if (!v || !(v.price > 0) || v.available === false) return;
      var p = Math.round(v.price * (100 - (+v.pct || 0)) / 100); if (p < bp) { bp = p; best = o[0]; } });
    return best;
  })();
  // the price shown for a build: its total when all 4 shelves are in, else "From": this rack + the shelves chosen + the
  // cheapest shelf for each one still to choose. -> {amount, total, sale, whole} or null (no price: never the rack alone)
  function priceOf(s) {
    var m = match(s), whole = !(m.shelvesLeft || []).length;
    var src = m;
    if (!whole && SLOTS && CHEAP) {
      var t = {}, k; for (k in s) t[k] = s[k];
      t.shelves = shelvesOf(s.shelves).map(function (x) { return x || CHEAP; });
      src = match(t);
    }
    if (!src.lines.length || src.missing.length) return null;
    var onSale = src.sale < src.total;
    return { amount: onSale ? src.sale : src.total, total: src.total, sale: src.sale, onSale: onSale, whole: whole };
  }

  // ---------- the Shelves step (each shelf product once: picture, name, price, the theme's quantity box; 4 in all) ----------
  var stepsEl = shelvesEl && shelvesEl.querySelector('[data-cr3d-steps]');
  function renderShelves() {
    if (!stepsEl) return;
    var s = state, h = '';
    if (SLOTS) {
      var cnt = shelfCounts(s.shelves), total = shelvesOf(s.shelves).filter(Boolean).length;
      h += '<fieldset class="cr3d__step" data-step="shelves"><legend class="label">' + esc(T.step_shelves || 'Shelves') + ': <span class="cr3d__step-value">' +
        total + ' ' + esc(T.of || 'of') + ' 4</span></legend>' +
        '<p class="cr3d__help">' + esc(T.help_qty || 'Choose 4 shelves for inside the rack. Hex and round hold dumbbells, bumper holds plates, ball holds wall and medicine balls. They go in from the top, in the order you add them.') + '</p>' +
        // "Shelves layout" (Rhys, 3 Nov): list = one row per shelf with a line about it, grid = the picture cards
        '<div class="cr3d__shelves' + (LIST ? ' cr3d__shelves--list' : '') + '">' + SHELF_TYPES.map(function (o) {
          var v = V[SHELF_SKU[o[0]]] || {}, n = cnt[o[0]] || 0, max = n + 4 - total, id = 'cr3d-sq-' + o[0];
          var name = String(v.title || SHELF_NAME[o[0]] || o[1]).split(' · ')[0], pct = +v.pct || 0, sale = v.price ? Math.round(v.price * (100 - pct) / 100) : 0;
          var price = BUY && v.price ? (sale < v.price ? money(sale) + ' <s class="cr3d__was">' + money(v.price) + '</s>' : money(v.price)) : '';
          return '<div class="cr3d__shelf' + (n ? ' is-on' : '') + '">' +
            '<div class="cr3d__shelf-img">' + (v.image ? '<img src="' + esc(v.image) + '" alt="" width="300" height="300" loading="lazy">' : '') + '</div>' +
            (LIST ? '<div class="cr3d__shelf-text"><p class="cr3d__shelf-name">' + esc(name) + '</p>' + (NOTES[o[0]] ? '<p class="cr3d__shelf-note">' + esc(NOTES[o[0]]) + '</p>' : '') + '</div>'
              : '<p class="cr3d__shelf-name">' + esc(name) + '</p>') + (price ? '<p class="cr3d__shelf-price">' + price + '</p>' : '') +
            '<quantity-input class="inline-block"><label class="label visually-hidden" for="' + id + '">' + esc((T.qty || 'Quantity') + ': ' + name) + '</label>' +
            '<div class="qty-input qty-input--combined inline-flex items-center w-full">' +
            '<button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus" aria-controls="' + id + '"' + (n > 0 ? '' : ' disabled') + '><span class="visually-hidden">' + esc(T.qty_less || 'Decrease quantity') + '</span></button>' +
            '<input type="number" class="qty-input__input input" id="' + id + '" data-g="shelfqty" data-v="' + o[0] + '" min="0" max="' + max + '" value="' + n + '" inputmode="numeric">' +
            '<button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus" aria-controls="' + id + '"' + (n < max ? '' : ' disabled') + '><span class="visually-hidden">' + esc(T.qty_more || 'Increase quantity') + '</span></button>' +
            '</div></quantity-input></div>';
        }).join('') + '</div></fieldset>';
    } else {
      h += '<fieldset class="cr3d__step" data-step="shelves"><legend class="label">' + esc(T.step_shelves || 'Shelves') + '</legend><div class="cr3d__layouts">' +
        CR.LAYOUTS.map(function (L) { var id = 'cr3d-lay-' + L.id; return '<input type="radio" class="opt-btn visually-hidden focus-label" name="cr3d-layout" id="' + id + '" value="' + esc(L.id) + '" data-g="layout" data-v="' + esc(L.id) + '"' + (state.layout === L.id ? ' checked' : '') + '>' +
          '<label class="opt-label opt-label--btn btn relative text-start cr3d__layout" for="' + id + '"><b>' + esc(L.short) + '</b><small>' + esc(L.label.replace(/x(\d)/g, '$1×')) + '</small></label>'; }).join('') + '</div></fieldset>';
    }
    stepsEl.innerHTML = h;
  }
  if (shelvesEl) {
    shelvesEl.addEventListener('change', function (e) {
      var b = e.target;
      // the theme's own listeners (finance, sticky bar, variant picker) never see the shelves
      e.stopPropagation();
      if (!b || !b.matches || !b.matches('input[data-g]') || b.disabled) return;
      var focusId = b.id, act = D.activeElement;
      var stepBtn = act && act.classList && act.classList.contains('qty-input__btn') ? act.getAttribute('name') : null;
      if (b.dataset.g === 'shelfqty') set({ shelves: setShelfCount(state.shelves, b.dataset.v, Math.max(0, parseInt(b.value, 10) || 0)) });
      else if (b.dataset.g === 'layout') set({ layout: b.dataset.v });
      // a tapped + / − keeps the focus on that button (the number box would open the phone keyboard)
      if (!stepBtn && b.dataset.g === 'shelfqty' && act !== b) stepBtn = 'plus';
      var again = stepBtn ? shelvesEl.querySelector('[aria-controls="' + focusId + '"][name="' + stepBtn + '"]') : D.getElementById(focusId);
      if (again && again.disabled && stepBtn) again = shelvesEl.querySelector('[aria-controls="' + focusId + '"]:not([disabled])');
      if (again && !again.disabled) again.focus({ preventScroll: true });
    });
    shelvesEl.addEventListener('input', function (e) { e.stopPropagation(); });
  }
  main.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-quote-open], [data-cr3d-quote]');
    if (q && main.contains(q)) { e.preventDefault(); openQuote(); }
  });

  // ---------- the build into main-product's price, Shop Pay, Finance, Add to cart and the sticky bar ----------
  var last = null, lastPrice = null;
  function rackVariantId(s) {
    var c = CR.colourOf(s.colour), b = RACK[s.height];
    var v = b ? (c && c.hex !== '#000000' && !c.custom ? find(CR.colourSku(b, s.colour)) : find(b)) : null;
    return v ? v.id : 0;
  }
  var PRICE_HTML = '<div class="price"><div class="price__default"><span class="price__current"><span class="visually-hidden js-label"></span> <span class="js-value"></span></span>' +
    ' <span class="price__was"><span class="visually-hidden js-label"></span> <span class="js-value"></span></span></div></div>';
  function writePrice(p) {
    var box = main.querySelector('.product-price .product-info__price');
    if (!box || !BUY) return;
    var key = p ? rackVariantId(state) + ':' + p.amount + ':' + p.total + ':' + (p.whole ? 1 : 0) : 'none';
    var cv = box.querySelector('.price__current .js-value');
    if (box.getAttribute('data-cr3d-applied') === key && (!p || (cv && cv.textContent.trim() === money(p.amount)))) return;
    if (!p) { box.innerHTML = ''; box.setAttribute('data-cr3d-applied', key); return; }   // never the rack alone
    var pr = box.querySelector('.price'), cur = pr && pr.querySelector('.price__current'), val = cur && cur.querySelector('.js-value');
    if (!val || box.querySelector('[data-pdp-promo]')) { box.innerHTML = PRICE_HTML; pr = box.querySelector('.price'); cur = pr.querySelector('.price__current'); val = cur.querySelector('.js-value'); }
    var from = cur.querySelector('.price__from');
    if (!from) { from = D.createElement('span'); from.className = 'price__from'; from.textContent = T.from || 'From'; cur.insertBefore(from, val); cur.insertBefore(D.createTextNode(' '), val); }
    from.hidden = !!p.whole;
    pr.classList.toggle('price--on-sale', p.onSale); pr.classList.toggle('price--campaign', p.onSale); pr.classList.remove('price--sold-out');
    var labels = pr.querySelectorAll('.js-label'), was = pr.querySelector('.price__was'), wasVal = was && was.querySelector('.js-value');
    if (labels[0]) labels[0].textContent = p.onSale ? (T.sale_price || 'Sale price') : (T.regular_price || 'Regular price');
    if (labels[1]) labels[1].textContent = p.onSale ? (T.regular_price || 'Regular price') : '';
    val.textContent = money(p.amount);
    if (wasVal) wasVal.textContent = p.onSale ? money(p.total) : '';
    if (was) was.hidden = !p.onSale;
    box.setAttribute('data-cr3d-applied', key);
  }
  // Shop Pay instalments: every rack variant's entry rewritten to that variant's build amount (the element follows main's
  // id input on a variant change, so each entry must already be right), as live snippets/pdp-cro.liquid fixTerms; its
  // pop-up's "check out" button (the rack alone) is hidden, as the theme does on product cards
  function termsAmounts() {
    var out = {};
    Object.keys(RID).forEach(function (id) {
      var r = rackOf(id); if (!r || !r.colour) return;
      var t = {}, k; for (k in state) t[k] = state[k]; t.height = r.height; t.colour = r.colour;
      var p = priceOf(t); if (p) out[id] = p.amount;
    });
    return out;
  }
  // the variant shown now: main's form id (Shopify never updates the terms element's own variant-id attribute; the original
  // element follows the form's id internally, a replaced copy starts from its variant-id attribute, so that is set here)
  function termsId() {
    var inp = main.querySelector('form.js-product-form-main input[name="id"]') || main.querySelector('form.js-instalments-form input[name="id"]');
    return inp && inp.value ? String(inp.value) : '';
  }
  function termsKey(p) { return termsId() + ':' + (p ? p.amount : 'none') + ':' + shelvesOf(state.shelves).join(','); }
  // Shop Pay is redrawn by Shopify inside a new element, empty at first: drawn hidden on top of the one showing and swapped
  // only once it has content, with the line keeping the tallest height it has had, so nothing below it jumps (Rhys, 3 Nov)
  var termsPending = null;
  function termsShown() { return main.querySelector('form.js-instalments-form shopify-payment-terms:not([data-cr3d-pending])'); }
  function termsCurrent() { return termsPending && termsPending.isConnected ? termsPending : termsShown(); }
  function termsSwap(el, copy, n) {
    if (termsPending !== copy || !copy.isConnected) return;
    var sh = copy.shadowRoot;
    if ((!sh || !sh.textContent.trim()) && (n || 0) < 60) { setTimeout(function () { termsSwap(el, copy, (n || 0) + 1); }, 50); return; }
    var form = copy.parentNode;
    if (el.isConnected) el.remove();
    copy.removeAttribute('data-cr3d-pending'); copy.removeAttribute('style');
    termsPending = null;
    if (form && form.style) { form.style.minHeight = ''; var hh = form.offsetHeight; form.cr3dMinH = Math.max(form.cr3dMinH || 0, hh); form.style.minHeight = form.cr3dMinH + 'px'; }
  }
  function writeTerms(p, amounts) {
    var el = termsShown();
    if (!el || !BUY) return;
    var id = termsId() || el.getAttribute('variant-id'), key = termsKey(p), cur = termsCurrent();
    if (cur && cur.getAttribute('data-cr3d-terms') === key) return;
    if (termsPending && termsPending !== el) { termsPending.remove(); termsPending = null; }
    var copy = el.cloneNode(false);
    if (id) copy.setAttribute('variant-id', id);
    try {
      var meta = JSON.parse(el.getAttribute('shopify-meta'));
      amounts = amounts || termsAmounts();
      var fmt = function (old, amt) { var comma = /\d,\d{2}(?!\d)/.test(old); return String(old).replace(/\d[\d.,\s]*\d/, amt.toLocaleString(comma ? 'de-DE' : 'en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
      (meta.variants || []).forEach(function (v) {
        var cents = amounts[String(v.id)]; if (cents == null) return;
        var full = Math.round(cents) / 100, per = Math.round(full / (v.number_of_payment_terms || 3) * 100) / 100;
        v.price_per_term = fmt(v.price_per_term, per); v.price_per_term_amount = per;
        v.full_price = fmt(v.full_price, full); v.full_price_amount = full;
      });
      copy.setAttribute('shopify-meta', JSON.stringify(meta));
    } catch (e) {}
    copy.setAttribute('data-pdp-done', '1');
    copy.setAttribute('data-cr3d-terms', key);
    // the first one (still empty, hidden by the section's early style) is simply replaced; after that, drawn behind
    var form = el.parentNode, drawn = el.shadowRoot && el.shadowRoot.textContent.trim() && el.hasAttribute('data-cr3d-terms');
    if (!drawn || !form) { el.replaceWith(copy); termsCta(copy); return; }
    if (getComputedStyle(form).position === 'static') form.style.position = 'relative';
    form.cr3dMinH = Math.max(form.cr3dMinH || 0, form.offsetHeight); form.style.minHeight = form.cr3dMinH + 'px';
    copy.setAttribute('data-cr3d-pending', '');
    copy.setAttribute('style', 'position:absolute;left:0;right:0;top:' + el.offsetTop + 'px;visibility:hidden;pointer-events:none');
    el.after(copy);
    termsPending = copy;
    termsCta(copy);
    termsSwap(el, copy);
  }
  function termsCta(el, n) {
    if (!G.customElements) return;
    customElements.whenDefined('shopify-payment-terms').then(function () {
      var sh = el.shadowRoot;
      if (!sh || !sh.childNodes.length) { if ((n || 0) < 120 && el.isConnected) setTimeout(function () { termsCta(el, (n || 0) + 1); }, 50); return; }
      if (sh.querySelector('style[data-cr3d]')) return;
      // kept in place, its size kept (so the price block is as tall as main-product's), but not shown or clickable
      var st = D.createElement('style'); st.setAttribute('data-cr3d', ''); st.textContent = '#shopify-installments-cta { visibility: hidden !important; pointer-events: none !important; }';
      sh.appendChild(st);
    });
  }
  // Finance (snippets/finance-options: Klarna in 3, Clearpay and PayPal in 4) for the build
  var FIN = [['.finance-klarna-amount', 3], ['.finance-clearpay-amount', 4], ['.finance-paypal-amount', 4]];
  function financeOff(p) {
    if (!p || !BUY) return false;
    return FIN.some(function (f) { var el = D.querySelector(f[0]); return el && el.textContent !== money(Math.floor(p.amount / f[1])); });
  }
  function writeFinance(p) {
    if (!p || !BUY) return;
    FIN.forEach(function (f) { var t = money(Math.floor(p.amount / f[1])); D.querySelectorAll(f[0]).forEach(function (el) { if (el.textContent !== t) el.textContent = t; }); });
  }
  // Add to cart: "Choose N more shelves" until the 4 are in (never disabled: the sticky bar copies a disabled button and its
  // tap then goes nowhere); "Request a quote" when a part can't be sold online
  function atcButton() { return main.querySelector('form.js-product-form-main button[name="add"]'); }
  function atcLabel(m) {
    var left = (m.shelvesLeft || []).length;
    if (left === 4 || (left && !shelvesOf(state.shelves).some(Boolean))) return T.choose_n || 'Choose 4 shelves';
    if (left === 1) return T.choose_one_more || 'Choose 1 more shelf';
    if (left) return (T.choose_more || 'Choose [n] more shelves').replace('[n]', left);
    if (m.reason === 'cart') return T.add || 'Add to cart';
    return T.quote || 'Request a quote';
  }
  function atcOff(m) { var b = atcButton(); if (!b || b.disabled) return false; return b.textContent.replace(/\s+/g, ' ').trim() !== atcLabel(m); }
  function writeAtc(m) {
    var b = atcButton(); if (!b) return;
    b.classList.toggle('cr3d-atc--todo', (m.shelvesLeft || []).length > 0);
    if (b.disabled) return;   // the rack variant is sold out: the theme's own wording
    var want = atcLabel(m);
    if (b.textContent.replace(/\s+/g, ' ').trim() !== want) b.innerHTML = '<span class="btn__label">' + esc(want) + '</span>';
  }
  // the phone sticky bar (Mobile PDP header): its price source is re-read (main re-renders the price on every variant change),
  // its label is the button's own while shelves are missing, and it watches the current Add to cart row
  var stickyIO = null, stickyLabel, chipPrices = null;
  function writeSticky(m, p, amounts) {
    var st = D.querySelector('pdp-sticky-atc');
    if (!st || !st.section) return;
    var ps = main.querySelector('.product-price .product-info__price');
    if (ps) st.priceSrc = ps;
    if (st.priceEl && ps && st.priceEl.innerHTML !== ps.innerHTML) { st.priceEl.innerHTML = ps.innerHTML; st.lastPrice = ps.innerHTML; }
    // the variant chip ("2.2M / SIGNATURE BLACK · £x", as on main-product): each variant's price is that variant's build
    // ("From £x" until the 4 shelves are in); it renders from its own variants list on every sync
    if (st.chip && Array.isArray(st.variants) && BUY) {
      if (!chipPrices) { chipPrices = {}; st.variants.forEach(function (v) { chipPrices[v.id] = v.price; }); }
      var from = p && !p.whole ? esc(T.from || 'From') + ' ' : '';
      st.variants.forEach(function (v) {
        var c = amounts && amounts[String(v.id)];
        v.price = c != null ? from + money(c) : chipPrices[v.id];
      });
      if (typeof st.renderChip === 'function') { try { st.renderChip(st.classList.contains('is-choose')); } catch (e) {} }
    }
    if (stickyLabel === undefined) stickyLabel = st.customLabel;
    var want = (m.shelvesLeft || []).length || m.reason !== 'cart' ? '' : stickyLabel;
    // shelves still to choose: the bar shows the button's own words ("Choose 3 more shelves") when they fit beside the
    // variant chip, else a short "Pick shelves" (a tap still goes to the shelves)
    if ((m.shelvesLeft || []).length && st.labelEl && st.btn && st.btn.clientWidth) {
      var lab = st.labelEl, was = lab.textContent;
      lab.textContent = atcLabel(m);
      if (st.btn.scrollWidth > st.btn.clientWidth + 1) want = T.sticky_todo || 'Pick shelves';
      lab.textContent = was;
    }
    if (st.customLabel !== want) st.customLabel = want;
    var row = main.querySelector('.product-info__add-to-cart');
    if (row && st.target && st.target !== row && 'IntersectionObserver' in G && typeof st.update === 'function') {
      st.target = row;
      if (stickyIO) stickyIO.disconnect();
      stickyIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { st.btnVisible = e.isIntersecting; if (!e.isIntersecting && e.boundingClientRect.top < 0) st.passed = true; if (e.isIntersecting) st.passed = false; });
        st.update();
      });
      stickyIO.observe(row);
    }
    if (typeof st.sync === 'function') st.sync();
  }
  function writeWhy(m) {
    var why = shelvesEl && shelvesEl.querySelector('[data-cr3d-why]'), qb = shelvesEl && shelvesEl.querySelector('[data-cr3d-quote]');
    var left = (m.shelvesLeft || []).length, t = '';
    if (!BUY) t = left ? (T.why_more || 'Choose') + ' ' + left + ' ' + (left === 1 ? (T.more_shelf || 'more shelf') : (T.more_shelves || 'more shelves')) + ' ' + (T.why_shelves_quote_end || 'to request your quote.')
      : (T.why_quote || 'Send us your build and our team will be in touch with a quote.');
    else if (!left && m.reason === 'unavailable') t = (T.why_unavailable || 'Some parts are out of stock online:') + ' ' + m.unavailable.join(', ') + '. ' + (T.why_unavailable_end || 'Send us your build and our team will confirm stock and delivery.');
    else if (!left && m.reason === 'missing') t = (T.why_missing || 'Some parts in this build are priced to order:') + ' ' + m.missing.map(function (x) { return x.name; }).join(', ') + '. ' + (T.why_missing_end || 'Send us your build for a quote.');
    if (why) { if (why.textContent !== t) why.textContent = t; why.hidden = !t; }
    if (qb) qb.hidden = left > 0;
  }
  function apply() {
    var m = match(state); last = m; NS.last = m;
    var p = BUY ? priceOf(state) : null; lastPrice = p;
    var amounts = BUY ? termsAmounts() : null;
    writePrice(p); writeTerms(p, amounts); writeFinance(p); writeAtc(m); writeWhy(m); writeSticky(m, p, amounts);
    sizeFirst();
  }
  // something of main's re-rendered (a variant change, a cached section): put the build back, comparing first (no loops)
  function off() {
    if (!last) return true;
    if (BUY) {
      var box = main.querySelector('.product-price .product-info__price');
      if (box && !box.hasAttribute('data-cr3d-applied')) return true;
      var cv = box && box.querySelector('.price__current .js-value');
      if (lastPrice && cv && cv.textContent.trim() !== money(lastPrice.amount)) return true;
      var tm = termsCurrent();
      if (tm && tm.getAttribute('data-cr3d-terms') !== termsKey(lastPrice)) return true;
      if (financeOff(lastPrice)) return true;
    }
    return atcOff(last);
  }
  var queued = false;
  function later() { if (queued) return; queued = true; setTimeout(function () { queued = false; if (off()) apply(); else sizeFirst(); }, 16); }
  // Height / Colour: main's variant picker (its on:variant:change comes after the theme's own updates; deferred past the
  // Finance and Mobile PDP header listeners). A quick-add drawer elsewhere on the page also fires it: the build goes back in.
  // The build goes in straight away (no rack-alone figures in between), then once more after the other listeners.
  D.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant, inMain = e.target && e.target.nodeType === 1 && main.contains(e.target);
    var go = function () {
      var r = inMain && v ? rackOf(v.id) : null;
      if (r && r.colour && (r.height !== state.height || r.colour !== state.colour)) set({ height: r.height, colour: r.colour }, 'variant');
      else apply();
    };
    go();
    setTimeout(function () { if (off()) apply(); }, 16);
  });
  var info = main.querySelector('.product-info') || main;
  if ('MutationObserver' in G) new MutationObserver(later).observe(info, { childList: true, subtree: true });

  // ---------- Add to cart: the whole build ----------
  var bandEl = main.querySelector('[data-cr3d-band]');
  function bandH() { return phone.matches && bandEl && main.classList.contains('cr3d-main--pin') && !main.classList.contains('cr3d-band-off') ? bandEl.getBoundingClientRect().bottom : 0; }
  function goTo(el) {
    if (!el) return;
    var top = Math.max(bandH(), parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--announcement-height')) || 0);
    G.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + G.scrollY - top - 16), behavior: 'smooth' });
    el.classList.remove('cr3d--flash'); void el.offsetWidth; el.classList.add('cr3d--flash');
  }
  var adding = false;
  var isMainForm = function (f) { return !!(f && f.matches && f.matches('form.js-product-form-main') && main.contains(f)); };
  // 1) window, capture (the add-on section's inline listeners, registered while the page is parsed, so before any app's):
  //    an incomplete build goes to the shelves; a build with parts that can't be sold online asks for a quote; nothing is
  //    added. Globo Product Options (while the product is still in its "3 Series Shelving" set it puts its required shelf
  //    pickers in main's form, hidden here, and guards Add to cart from window too): its guard is skipped and the build is
  //    added from here (the phone fly-to-cart is started by hand).
  var globo = function () { return !!(main.querySelector('form.js-product-form-main :is(.gpo-app, .gpo-container)') || (G.GPOConfigs && G.GPOConfigs.diagAtc)); };
  NS.guard = function (e) {
    var form, btn;
    if (e.type === 'click') {
      btn = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!btn || btn.name !== 'add' || !isMainForm(btn.form)) return;
      form = btn.form;
    } else { form = e.target; if (!isMainForm(form)) return; }
    var m = last || match(state);
    if ((m.shelvesLeft || []).length) { e.preventDefault(); e.stopImmediatePropagation(); G.__pdpStickyClick = false; goTo(shelvesEl && shelvesEl.querySelector('[data-step="shelves"]')); return; }
    if (m.reason !== 'cart') { e.preventDefault(); e.stopImmediatePropagation(); G.__pdpStickyClick = false; openQuote(); return; }
    if (!globo()) return;   // the theme's way: the fly-to-cart listeners start, then takeOver() below
    if (e.type === 'click') { e.stopImmediatePropagation(); return; }   // the submit follows
    e.preventDefault(); e.stopImmediatePropagation();
    var b = form.querySelector('button[name="add"]');
    if (adding || (b && b.getAttribute('aria-disabled') === 'true')) return;
    try { var sticky = D.querySelector('pdp-sticky-atc.is-in .pdp-satc__btn'); if (typeof G.__pdpFly === 'function' && b) G.__pdpFly(G.__pdpStickyClick && sticky ? sticky : b); } catch (x) {}
    G.__pdpStickyClick = false;
    setTimeout(function () { runAdd(form); }, 0);
  };
  // 2) document, capture, registered after the theme's inline fly listeners (so they still start): the whole build instead
  //    of the rack alone. Not aria-disabled here (a later fly listener would skip); the add starts after this event.
  function takeOver(e) {
    if (!isMainForm(e.target)) return;
    var m = last;
    if (!m || m.reason !== 'cart' || (m.shelvesLeft || []).length) return;
    e.preventDefault(); e.stopPropagation();
    var form = e.target;
    setTimeout(function () { runAdd(form); }, 0);
  }
  if (D.readyState === 'complete') D.addEventListener('submit', takeOver, true);
  else D.addEventListener('DOMContentLoaded', function () { D.addEventListener('submit', takeOver, true); });
  // Rebuy "Recommended Add Ons" (main's app block, kept from live): on main-product Rebuy adds the ticked add-ons from its own
  // submit listener on the form, which never runs here (the build's add stops the submit first). So they are added here, as
  // Rebuy would (its own line data: quantity and _source / _widget_id / _attribution properties), after the build and not
  // as part of it.
  function rebuyItems() {
    var out = [];
    try {
      ((G.Rebuy && G.Rebuy.widgets) || []).forEach(function (w) {
        if (!w || !w.data || !w.data.settings || w.data.settings.type !== 'product_addon') return;
        // the rendered widget (#rebuy-widget-<id>; w.element can be the detached placeholder Rebuy mounted over)
        var el = D.getElementById('rebuy-widget-' + w.id) || (w.element && w.element.nodeType === 1 ? w.element : null);
        if (!el || !main.contains(el)) return;
        (w.data.products || []).forEach(function (p) {
          var sel = typeof w.productIsSelected === 'function' ? w.productIsSelected(p) : p.selected !== false;
          if (!sel || !p.selected_variant) return;
          if (typeof w.variantAvailable === 'function' && !w.variantAvailable(p.selected_variant)) return;
          var item = typeof w.addToCartData === 'function' ? w.addToCartData(p) : { id: p.selected_variant.id, quantity: p.quantity || 1 };
          if (item && item.id) out.push(item);
        });
      });
    } catch (e) {}
    return out;
  }
  function addRebuy(items, secs) {
    if (!items.length) return Promise.resolve(null);
    var root = (G.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var body = { items: items };
    if (secs) { body.sections = secs; body.sections_url = location.pathname; }
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  NS.rebuyItems = rebuyItems;
  function runAdd(form) {
    var C = G.CR3DCart, m = last;
    if (adding || !C || !m || m.reason !== 'cart' || !m.lines.length) return;
    adding = true;
    var btn = form.querySelector('button[name="add"]'), pf = form.closest('product-form') || form;
    var err = form.querySelector('.js-form-error'); if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    var qtyEl = form.querySelector('input[name="quantity"]'), qty = Math.max(1, Math.min(99, parseInt(qtyEl && qtyEl.value, 10) || 1));
    var drawer = D.querySelector('cart-drawer'), sec = drawer && drawer.closest('.shopify-section');
    var secId = sec ? sec.id.replace('shopify-section-', '') : '';
    var id = C.newBuildId(), c = CR.colourOf(state.colour);
    var label = C.buildLabel(id, { sku: m.lines[0].sku, height: state.height, colour: c ? c.name : '' });
    var lines = m.lines.map(function (l) { var o = {}, k; for (k in l) o[k] = l[k]; o.quantity = l.quantity * qty; return o; });
    var fail = function (msg) {
      try { pf.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: msg } })); } catch (x) {}
      if (drawer && drawer.refresh) { try { drawer.refresh(true); } catch (x) {} }
      if (err) { err.textContent = msg; err.hidden = false; }
    };
    var extras = rebuyItems(), secList = ['cart-icon-bubble', secId].filter(Boolean).join(',');
    C.addBuild({ lines: lines, buildId: id, label: label, drawerSectionId: secId, target: pf, allOrNothing: true,
      visibleProperty: { name: T.cart_property || 'Build', value: summaryOf(state) } })
      .then(function (r) {
        if (!extras.length || !(r.status === 'ok' || r.status === 'partial')) return r;
        // the add-ons after the build: the drawer then shows the cart with both (their response's sections)
        return addRebuy(extras, r.data && r.data.sections ? secList : '').then(function (x) {
          if (x && x.sections && r.data && r.data.sections) { var k; for (k in x.sections) if (x.sections[k]) r.data.sections[k] = x.sections[k]; }
          return r;
        });
      })
      .then(function (r) {
        var after = G.theme && theme.settings ? theme.settings.afterAtc : 'drawer';
        if (r.status === 'ok' && r.data && r.data.sections) {
          if (after === 'page') { setTimeout(function () { location.href = (G.theme && theme.routes && theme.routes.cart) || cfg.cart_url || '/cart'; }, 300); return; }
          var PF = G.customElements && customElements.get('product-form');
          if (PF && PF.updateCartIcon) { try { PF.updateCartIcon(r.data); } catch (x) {} }
          setTimeout(function () { if (drawer && drawer.renderContents) drawer.renderContents(r.data, after === 'drawer'); }, 700);
          return;
        }
        if (r.status === 'ok' || r.status === 'partial') return C.showInDrawer(r, { afterAtc: after, open: after === 'drawer', drawerSectionId: secId, cartUrl: cfg.cart_url || '/cart' });
        var msg = r.status === 'rolledback'
          ? (T.rolledback || 'This part isn’t available online right now, so your cart hasn’t changed:') + ' ' + r.failed.map(function (f) { return f.title; }).join(', ') + '.'
          : (T.add_failed || 'Your build couldn’t be added. Please try again or speak to the team.');
        fail(msg);
      })
      .catch(function () { fail(T.add_failed || 'Your build couldn’t be added. Please try again or speak to the team.'); })
      .then(function () {
        adding = false;
        var b = form.querySelector('button[name="add"]') || btn; if (!b) return;
        b.classList.add('is-success'); b.removeAttribute('aria-disabled');
        setTimeout(function () { b.classList.remove('is-loading', 'is-success'); }, 1400);
      });
  }

  // ---------- quote (the whole build, to the quote endpoint -> Freshsales) ----------
  var dlg = main.querySelector('[data-cr3d-dialog]'), openedAt = 0;
  function openQuote() {
    if (!dlg) return;
    dlg.querySelector('[data-cr3d-qsummary]').textContent = summaryOf(state);
    dlg.querySelector('[data-cr3d-qok]').hidden = true; dlg.querySelector('[data-cr3d-qform]').hidden = false;
    openedAt = Date.now();
    if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
  }
  if (dlg) {
    dlg.querySelectorAll('[data-cr3d-close]').forEach(function (b) { b.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }); });
    var qform = dlg.querySelector('[data-cr3d-qform]');
    qform.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = dlg.querySelector('[data-cr3d-qerr]'); err.hidden = true;
      if (!qform.checkValidity()) { qform.reportValidity(); return; }
      var fd = new FormData(qform), contact = {};
      fd.forEach(function (v, k) { contact[k] = String(v).trim(); });
      if (contact.website) return;   // honeypot
      var m = last, list = skuRows(state);
      var payload = { source: '3D Compact Rack Builder', product: cfg.product && cfg.product.handle, market: cfg.market || '', page: location.href,
        summary: summaryOf(state), details: detailsOf(state), parts: list.rows.map(function (r) { return { sku: r.sku, name: nice(r.name), qty: r.qty }; }),
        pricing: m ? { lines: m.lines.map(function (l) { return { sku: l.sku, name: l.title, qty: l.quantity, unit: money(l.price), total: money(l.price * l.quantity), note: l.unavailable ? 'out of stock online' : '' }; }),
          to_price: m.missing.map(function (x) { return { name: x.name, qty: x.qty }; }), total: m.lines.length ? money(m.total) : '', complete: !m.missing.length } : null,
        build: state, contact: contact, elapsed: Date.now() - openedAt };
      var send = dlg.querySelector('[data-cr3d-qsend]'); send.disabled = true; send.classList.add('is-loading');
      var withShot = NS.shot ? NS.shot(800, 600).catch(function () { return null; }) : Promise.resolve(null);
      withShot.then(function (img) {
        if (img && img.length < 400000) payload.image = img;
        if (!cfg.quote_endpoint) return contactForm(payload);
        return fetch(cfg.quote_endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) throw new Error('quote ' + r.status); });
      }).then(function () {
        qform.hidden = true; dlg.querySelector('[data-cr3d-qok]').hidden = false;
        try {
          var leadData = { form: '3d-rack-builder', build: summaryOf(state), market: cfg.market || '' };
          if (typeof G.blkLead === 'function') G.blkLead('3d-rack-builder', 'cr3d-' + Date.now(), leadData);
          else if (G.Shopify && G.Shopify.analytics && G.Shopify.analytics.publish) G.Shopify.analytics.publish('lead_submitted', Object.assign({ source: '3d-rack-builder', page: location.pathname }, leadData));
        } catch (x) {}
      }).catch(function () {
        err.textContent = T.quote_failed || 'Your request couldn’t be sent. Please try again, or call or email the team.'; err.hidden = false;
      }).then(function () { send.disabled = false; send.classList.remove('is-loading'); });
    });
  }
  function contactForm(p) {
    var body = [p.summary, '', p.parts.map(function (r) { return r.qty + ' x ' + r.name + ' (' + r.sku + ')'; }).join('\n'), '', 'Build link: ' + p.page, '', p.contact.message || ''].join('\n');
    var f = new FormData();
    f.append('form_type', 'contact'); f.append('utf8', '✓');
    f.append('contact[name]', p.contact.name || ''); f.append('contact[email]', p.contact.email || ''); f.append('contact[phone]', p.contact.phone || '');
    f.append('contact[Company]', p.contact.company || ''); f.append('contact[Postcode]', p.contact.postcode || ''); f.append('contact[Source]', '3D Compact Rack Builder');
    f.append('contact[body]', body);
    return fetch('/contact#contact_form', { method: 'POST', body: f, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('contact ' + r.status); });
  }

  // ---------- photos open full size; the view tiles turn the 3D (cr3d-view.js; before it has loaded it starts there) ----------
  var zoom = main.querySelector('[data-cr3d-zoom-dialog]');
  main.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('.cr3d-media [data-cr3d-zoom="photo"]');
    if (tile && zoom) {
      var zp = zoom.querySelector('[data-cr3d-zoom-photo]');
      zp.src = tile.getAttribute('data-cr3d-full'); zp.alt = (tile.querySelector('img') || {}).alt || '';
      if (!zoom.open) { if (zoom.showModal) zoom.showModal(); else zoom.setAttribute('open', ''); }
      return;
    }
    var look = e.target.closest && e.target.closest('.cr3d-media [data-cr3d-look]');
    if (look && !NS.view) {
      NS.pendingLook = look.getAttribute('data-cr3d-look');
      main.querySelectorAll('.cr3d-media [data-cr3d-look]').forEach(function (b) { b.setAttribute('aria-pressed', b === look ? 'true' : 'false'); });
      start3d();
    }
  });
  if (zoom) {
    zoom.querySelector('[data-cr3d-zoom-close]').addEventListener('click', function () { zoom.close(); });
    zoom.addEventListener('click', function (e) { if (e.target === zoom) zoom.close(); });
  }

  // ---------- layout: the 3D square beside the options ----------
  // desktop: the square keeps in view beside the header, options, shelves and Add to cart (its box runs that tall); then the
  // views and the photos scroll beside the rest of the info.
  var firstEl = main.querySelector('.cr3d__first');
  if (main.querySelector('.cr3d-media--sticky')) main.classList.add('cr3d-main--sticky');
  if (main.querySelector('.cr3d-media--pin')) main.classList.add('cr3d-main--pin');
  function endBlock() { return quoteEl || (main.querySelector('product-form') || {}).parentElement || shelvesEl; }
  var ssd = main.querySelector('sticky-scroll-direction');
  function sizeFirst() {
    if (!firstEl) return;
    // the square sticks at the same top as the theme's sticky info column (its defaultTop: 48px, or under a sticky header)
    var dt = ssd && +ssd.defaultTop > 0 ? ssd.defaultTop + 'px' : '';
    if (main.style.getPropertyValue('--cr3d-top-desk') !== dt) { if (dt) main.style.setProperty('--cr3d-top-desk', dt); else main.style.removeProperty('--cr3d-top-desk'); }
    var want = '';
    if (desk.matches && main.classList.contains('cr3d-main--sticky')) {
      var col = main.querySelector('.product-info__sticky') || main.querySelector('.product-info'), end = endBlock();
      if (col && end && end.getBoundingClientRect) want = Math.round(end.getBoundingClientRect().bottom - col.getBoundingClientRect().top) + 'px';
    }
    if (firstEl.style.getPropertyValue('--cr3d-first-h') !== want) { if (want) firstEl.style.setProperty('--cr3d-first-h', want); else firstEl.style.removeProperty('--cr3d-first-h'); }
  }
  // (also re-measured from the MutationObserver pass: an app block such as Rebuy's add-ons renders in late)
  if ('ResizeObserver' in G) { var ro = new ResizeObserver(function () { sizeFirst(); }); ro.observe(info); var colEl = main.querySelector('.product-info__sticky'); if (colEl && colEl !== info) ro.observe(colEl); }
  G.addEventListener('resize', sizeFirst);
  // phones: the pinned 3D band slides away as soon as the Add to cart row reaches its bottom edge (so the band never covers
  // the real button, and the sticky bar, which watches that row, is right about it), and comes back when the row is below it
  // again. The edge is where the band sits when shown: its sticky top (under the announcement bar, plus the header while
  // that is revealed) + its height, whether or not it is slid away at the moment.
  var bandQ = false;
  function bandBottom() {
    var top = parseFloat(getComputedStyle(bandEl).top);
    if (!(top >= 0)) top = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--announcement-height')) || 0;
    return top + bandEl.offsetHeight;
  }
  function band() {
    bandQ = false;
    if (!bandEl || !phone.matches || !main.classList.contains('cr3d-main--pin')) { main.classList.remove('cr3d-band-off'); return; }
    // (quote-only markets: their "Request a quote" button in the Shelves step, once shown, counts as that row)
    var row = main.querySelector('.product-info__add-to-cart');
    if (!(row && row.getClientRects().length)) row = shelvesEl && shelvesEl.querySelector('[data-cr3d-quote]:not([hidden])');
    if (row && row.getClientRects().length) { main.classList.toggle('cr3d-band-off', row.getBoundingClientRect().top < bandBottom()); return; }
    // no Add to cart (quote-only / no-price markets): once the end of the shelves (and the quote button) has gone under it
    var end = endBlock(); if (!end) return;
    main.classList.toggle('cr3d-band-off', end.getBoundingClientRect().bottom < bandBottom());
  }
  G.addEventListener('scroll', function () { if (!bandQ) { bandQ = true; setTimeout(band, 32); } }, { passive: true });
  if (phone.addEventListener) phone.addEventListener('change', function () { band(); sizeFirst(); });

  // ---------- the 3D view: loaded when the square is near (and soon after the page has loaded) ----------
  var started = false;
  function start3d() {
    if (started || !cfg.view_js) return; started = true;
    var s = D.createElement('script'); s.type = 'module'; s.src = cfg.view_js; s.onerror = function () { main.classList.add('cr3d--no3d'); };
    D.head.appendChild(s);
  }
  var near = main.querySelector('.cr3d__stage');
  if (near && 'IntersectionObserver' in G) new IntersectionObserver(function (es, o) { if (es.some(function (x) { return x.isIntersecting; })) { start3d(); o.disconnect(); } }, { rootMargin: '400px' }).observe(near);
  var soon = function () { setTimeout(start3d, 1200); };
  if (D.readyState === 'complete') soon(); else G.addEventListener('load', soon);

  renderShelves();
  apply();
  band();
  // the theme's sticky info column measures #product-media: tell it the media changed
  try { G.dispatchEvent(new Event('resize')); } catch (e) {}
})();
